import { type ServerPosCredApplicationInterface } from '@/components/App/PosCred/PosCredApclication/types/slice-types';
import { type PosCreditsServerInterface } from '@/components/App/PosCred/PosCreds/type';

import { ApiConnector } from '../api.connector';

class PosCredApi extends ApiConnector {
  private baseUrl = 'pos-credit';

  getPosCredList(
    params: GetPosCredListParams
  ): Promise<PosCreditsServerInterface> {
    return this.call({
      path: `${this.baseUrl}`,
      method: 'get',
      params
    });
  }

  getPosCredById(uuid: string): Promise<ServerPosCredApplicationInterface> {
    return this.call({
      path: `${this.baseUrl}/${uuid}`,
      method: 'get'
    });
  }

  retryOtp(requestId: string) {
    return this.call({
      path: `${this.baseUrl}/${requestId}/otp/retry`,
      method: 'post'
    });
  }

  generateDraftWithOtp(
    data: GenerateOtpData & { dealerId: string }
  ): Promise<{ request_uuid: string }> {
    return this.call({
      path: `${this.baseUrl}/generateDraftWithOtp`,
      method: 'post',
      body: data
    });
  }

  validatePosCredOtp(data: ValidateOtp): Promise<{ uuid: string }> {
    return this.call({
      path: `${this.baseUrl}/validateOTP`,
      method: 'post',
      body: data
    });
  }

  updatePosCred({ request_uuid, body }: UpdatePosCredRequestInterface) {
    return this.call({
      path: `${this.baseUrl}/${request_uuid}`,
      method: 'patch',
      body
    });
  }

  acceptOffer(offerId: string) {
    return this.call({
      path: `${this.baseUrl}/offers/${offerId}/accept`,
      method: 'post'
    });
  }

  refundOffer(offerId: string) {
    return this.call({
      path: `${this.baseUrl}/offers/${offerId}/refund`,
      method: 'post'
    });
  }

  cancelOffer(offerId: string) {
    return this.call({
      path: `${this.baseUrl}/offers/${offerId}/reject`,
      method: 'post'
    });
  }
}

export const posCreditApi = new PosCredApi();

export interface GetPosCredListParams {
  searchTerm?: string;
  dealerId?: string;
  offset?: number;
  limit?: number;
  filterByUser?: string;
}

export interface UpdatePosCredRequestInterface {
  request_uuid: string;
  body: {
    client_iin: string;
    dealer_code: number;
    loan_amount: number;
    loan_term: number | null;
    phone_number: string;
    product_bank_id: string;
    product_dc: string;
    product_code: string;
    uuid: string;
  };
}

interface GenerateOtpData {
  iin: string;
  clientPhone: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
}

interface ValidateOtp {
  otp: string;
  request_uuid: string;
}
